import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "boxicons/css/boxicons.min.css";
import "./App.css";

import { ToastProvider, useToast } from "./components/ToastProvider";
import { setToastFn } from "./toastService";

import LanguageSelection from "./pages/LanguageSelection";
import Onboarding from "./pages/Onboarding";
import Login from "./pages/Login";
import Otp from "./pages/Otp";
import ProfileStep1 from "./pages/ProfileStep1";
import Dashboard from "./pages/Dashboard";
import Favorites from "./pages/Favorites";
import MyWorks from "./pages/MyWorks";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import PastWorks from "./pages/PastWorks";
import AddPastWork from "./pages/AddPastWork";
import AddWork from "./pages/AddWork";
import EditWork from "./pages/EditWork";
import EditPastWork from "./pages/EditPastWork";
import Notifications from "./pages/Notifications";
import WorkPreferences from "./pages/WorkPreferences";
import LanguagePreferences from "./pages/LanguagePreferences";
import WorkDetails from "./pages/WorkDetails";
import FindContractors from "./pages/FindContractors";
import FavoriteContractors from "./pages/FavoriteContractors";
import ContractorDetails from "./pages/ContractorDetails";

function App() {
  return (
    <ToastProvider>
      <Initializer />
    <Router>
      <div className="app-container">
        <Routes>
          <Route path="/" element={<LanguageSelection />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/login" element={<Login />} />
          <Route path="/otp" element={<Otp />} />
          <Route path="/profile-step-1" element={<ProfileStep1 />} /> 
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/my-works" element={<MyWorks />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/past-works" element={<PastWorks />} />
          <Route path="/add-past-work" element={<AddPastWork />} />
          <Route path="/add-work" element={<AddWork />} />
          <Route path="/edit-work/:id" element={<EditWork />} />
          <Route path="/edit-past-work/:id" element={<EditPastWork />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/work-preferences" element={<WorkPreferences />} />
          <Route path="/language-preferences" element={<LanguagePreferences />} />
          <Route path="/work/:id" element={<WorkDetails />} />
          <Route path="/find-contractors" element={<FindContractors />} />
          <Route path="/favorite-contractors" element={<FavoriteContractors />} />
          <Route path="/contractor/:id" element={<ContractorDetails />} />
          {/* Future routes can be added here */}
          {/* <Route path="/home" element={<Home />} /> */}
        </Routes>
      </div>
    </Router>
    </ToastProvider>
  );
}

function Initializer() {
  const { showToast } = useToast();
  setToastFn(showToast); // connect global function
  return null;
}

export default App;